import { css, SerializedStyles } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getInsuranceSelectStyles = (theme: Theme): SerializedStyles =>
    css({
        backgroundColor: theme.palette.gray[100],
        padding: theme.spacing(2),
        borderRadius: theme.borderRadius.S,
    });

export const getInsuranceInfoSectionStyles =
    (hasVerticalLayout: boolean) =>
    (theme: Theme): SerializedStyles =>
        css({
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: theme.spacing(),

            [theme.mediaQuery('tablet')]: {
                gap: theme.spacing(2),
                flexWrap: hasVerticalLayout ? 'wrap' : 'nowrap',
            },
        });

export const getTextSectionStyles =
    (hasVerticalLayout: boolean) =>
    (theme: Theme): SerializedStyles =>
        css({
            [theme.mediaQuery('tablet')]: {
                ...(!hasVerticalLayout && {
                    flex: 1,
                }),
            },
        });

export const getInsuranceTitleTextStyles = (): SerializedStyles =>
    css({
        display: 'flex',
        alignItems: 'center',
        margin: 0,
    });

export const getInsuranceSubtitleTextStyles = (): SerializedStyles =>
    css({
        margin: 0,
    });

export const getInsuranceSubtitleIconStyles = (theme: Theme): SerializedStyles =>
    css({
        marginRight: theme.spacing(0.5),
    });

export const getInsuranceCardStyles =
    (isChecked: boolean) =>
    (theme: Theme): SerializedStyles =>
        css({
            padding: theme.spacing(3),
            backgroundColor: theme.palette.white,
            border: `1px solid ${isChecked ? theme.palette.gray[900] : theme.palette.gray.light}`,
            borderRadius: theme.borderRadius.S,
            flexGrow: 1,
        });

export const getRadioStyles = (): SerializedStyles =>
    css({
        width: '100%',
        alignItems: 'baseline',
    });

export const getInsuranceTextStyles = (): SerializedStyles =>
    css({
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    });
